import React from 'react';
import { Box, useTheme } from '@ublend-npm/aulaui-core';
import { createStyles } from './CommonRoomResponsive.styles';

interface CommonRoomContentProps {
  children?: React.ReactNode;
  label: string;
}

const CommonRoomContent = ({ children, label }: CommonRoomContentProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box component="main" sx={styles.content} aria-label={label}>
      {children}
    </Box>
  );
};

export default CommonRoomContent;
